import chase1 from "../../../assets/images/background/chase/1.png";
import chase2 from "../../../assets/images/background/chase/2.png";
import chase3 from "../../../assets/images/background/chase/3.png";
import chase4 from "../../../assets/images/background/chase/4.png";
import chase5 from "../../../assets/images/background/chase/5.png";
import chase6 from "../../../assets/images/background/chase/6.png";
import chase7 from "../../../assets/images/background/chase/7.png";
import chase8 from "../../../assets/images/background/chase/8.png";
import chase9 from "../../../assets/images/background/chase/9.png";
import chase10 from "../../../assets/images/background/chase/10.png";
import chase11 from "../../../assets/images/background/chase/11.png";
import buildings from "../../../assets/images/background/chase/buildings.png";
import fountain from "../../../assets/images/background/chase/fountain.png";

const chase = {
	name: "Chase",
	components: {
		chase_1: {
			id: "chase_1",
			image: chase1,
			text: "chase tile 1",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 41, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 0, y2: 59 },
			],
			waters: [],
		},
		chase_2: {
			id: "chase_2",
			image: chase2,
			text: "chase tile 2",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 59, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 59, y2: 0 },
				{ x1: 0, y1: 41, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 41, y2: 0 },
			],
			waters: [],
		},
		chase_3: {
			id: "chase_3",
			image: chase3,
			text: "chase tile 3",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 59, x2: 100, y2: 59 },
				{ x1: 0, y1: 41, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 41, y2: 0 },
				{ x1: 59, y1: 0, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 100, y2: 41 },
			],
			waters: [],
		},
		chase_4: {
			id: "chase_4",
			image: chase4,
			text: "chase tile 4",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 59, x2: 100, y2: 59 },
				{ x1: 0, y1: 41, x2: 100, y2: 41 },
			],
			waters: [],
		},
		chase_5: {
			id: "chase_5",
			image: chase5,
			text: "chase tile 5",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 13, y1: 41, x2: 87, y2: 41 },
				{ x1: 87, y1: 41, x2: 87, y2: 59 },
				{ x1: 87, y1: 59, x2: 13, y2: 59 },
				{ x1: 13, y1: 59, x2: 13, y2: 41 },
			],
			waters: [],
		},
		chase_6: {
			id: "chase_6",
			image: chase6,
			text: "chase tile 6",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 41, y1: 0, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 13, y2: 41 },
				{ x1: 13, y1: 41, x2: 13, y2: 59 },
				{ x1: 13, y1: 59, x2: 41, y2: 59 },
				{ x1: 41, y1: 59, x2: 41, y2: 100 },
				{ x1: 59, y1: 0, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 87, y2: 41 },
				{ x1: 87, y1: 41, x2: 87, y2: 59 },
				{ x1: 87, y1: 59, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 59, y2: 100 },
			],
			waters: [],
		},
		chase_7: {
			id: "chase_7",
			image: chase7,
			text: "chase tile 7",
			pois: { name: "", items: [] },
			walls: [],
			waters: [],
		},
		chase_8: {
			id: "chase_8",
			image: chase8,
			text: "chase tile 8",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 41, x2: 87, y2: 41 },
				{ x1: 87, y1: 41, x2: 87, y2: 59 },
				{ x1: 87, y1: 59, x2: 0, y2: 59 },
			],
			waters: [],
		},
		chase_9: {
			id: "chase_9",
			image: chase9,
			text: "chase tile 9",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 41, y1: 0, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 13, y2: 41 },
				{ x1: 13, y1: 41, x2: 13, y2: 59 },
				{ x1: 13, y1: 59, x2: 41, y2: 59 },
				{ x1: 41, y1: 59, x2: 41, y2: 100 },
				{ x1: 59, y1: 0, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 100, y2: 41 },
				{ x1: 100, y1: 59, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 59, y2: 100 },
			],
			waters: [],
		},
		chase_10: {
			id: "chase_10",
			image: chase10,
			text: "chase tile 10",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 41, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 41, y2: 0 },
				{ x1: 59, y1: 0, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 100, y2: 41 },
				{ x1: 100, y1: 59, x2: 59, y2: 59 },
				{ x1: 59, y1: 59, x2: 59, y2: 100 },
				{ x1: 0, y1: 59, x2: 41, y2: 59 },
				{ x1: 41, y1: 59, x2: 41, y2: 100 },
			],
			waters: [],
		},
		chase_11: {
			id: "chase_11",
			image: chase11,
			text: "chase tile 11",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 0, y1: 59, x2: 100, y2: 59 },
				{ x1: 0, y1: 41, x2: 41, y2: 41 },
				{ x1: 41, y1: 41, x2: 41, y2: 11 },
				{ x1: 41, y1: 11, x2: 59, y2: 11 },
				{ x1: 59, y1: 11, x2: 59, y2: 41 },
				{ x1: 59, y1: 41, x2: 100, y2: 41 },
			],
			waters: [],
		},
		buildings: {
			id: "buildings",
			image: buildings,
			text: "Buildings",
			pois: { name: "", items: [] },
			walls: [],
			waters: [],
		},
		fountain: {
			id: "fountain",
			image: fountain,
			text: "Fountain",
			pois: { name: "", items: [] },
			walls: [
				{ x1: 29, y1: 29, x2: 71, y2: 29 },
				{ x1: 71, y1: 29, x2: 71, y2: 71 },
				{ x1: 71, y1: 71, x2: 29, y2: 71 },
				{ x1: 29, y1: 71, x2: 29, y2: 29 },
			],
			waters: [],
		},
	},
};

export default chase;
